export default "__VITE_ASSET__B8G8sA8o__"